function Introduction() {
  return (
    <section className="mt-16" id="about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-7 gap-y-16 sm:gap-16 w-full">
        <div className="col-span-7 lg:col-span-4">
          <h3 className="text-3xl font-black text-text-main mb-3 leading-tighter">
            What is a mastermind group?
          </h3>
          <p className="text-md text-text-main mb-3">
            Being a founder is difficult and lonely. We get it. Your family
            doesn't understand what you're doing at all. Your friends can't
            empathise, with their cushy corporate jobs. And{" "}
            <b>
              when you try attending networking events to chat with other
              founders, it becomes an ego-measuring contest , to see who's doing
              the best. It sucks - big time.
            </b>
          </p>
          <p className="text-md text-text-main mb-3">
            After all, who can you discuss the 1001 business problems you're
            facing with, as a founder? Well, that's where The 100 Club comes in.
            <b>
              More than an exclusive network of founders, we run masterminds.
              It's like business group therapy, for founders.
            </b>{" "}
            Our goal is to put you in a room with 5 other founders at a similar
            stage as you, that meet monthly to discuss business challenges. How
            does that help you?
          </p>
          <p className="text-md text-text-main mb-3">
            Well, these are the people you can openly share your challenges (and
            complaints) with, as well as actively brainstorm solutions with.{" "}
            <b>
              In this group, you will forge deep relationships with other
              founders who will be invested in your journey as much as you are
              in theirs.
            </b>
            Collectively, each of you will bring a combined plethora of
            experiences as entrepreneurs actively in the trenches.
          </p>
          <p className="text-md text-text-main mb-3">
            <b>Discuss your challenges with your peers</b>, who will give you
            their fullest attention, break down the problem with you, and give
            you useful critique and feedback.
          </p>
          <p className="text-md text-text-main mb-3">
            The mastermind is a concept that has been exclusive to the corporate
            elite, but The 100 Club is now bringing it to all founders
            throughout Singapore.{" "}
            <b>So what are you waiting for? Crash a trial session today.</b>
          </p>
        </div>
        <div className="col-span-6 lg:col-span-3">
          <div className="bg-highlight-eggshell p-7 rounded-md border mb-10">
            <p>
              "Entrepreneurship is a lonely journey. Whenever you try to share
              your experiences you’ll realise that most of your friends in
              corporate jobs wouldn’t understand. The mastermind groups bring
              together like-minded individuals which makes the journey a little
              less excruciating."
            </p>
            <h4 className="text-lg font-black mt-4">
              Wei Jun, Founder of Lalia
            </h4>
          </div>
          <div className="bg-highlight-eggshell p-7 rounded-md border">
            <p>
              "Finding a network of founders who have taken similar roads to you
              is hard. The 100 Club has accelerated my network growth, and I
              have met dedicated and friendly founders who are happy to share
              their journeys and solve problems together."
            </p>
            <h4 className="text-lg font-black mt-4">
              Ajinkya, Founder of SeamlessXR
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Introduction;
